import { render, staticRenderFns } from "./columns-settings-dialog-column.vue?vue&type=template&id=4f9f4537&scoped=true&"
import script from "./columns-settings-dialog-column.vue?vue&type=script&lang=ts&"
export * from "./columns-settings-dialog-column.vue?vue&type=script&lang=ts&"
import style0 from "./columns-settings-dialog-column.vue?vue&type=style&index=0&id=4f9f4537&lang=scss&scoped=true&"
import style1 from "./columns-settings-dialog-column.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9f4537",
  null
  
)

export default component.exports